import { useState } from "react";
import type { FormEvent } from "react";
import { navItems, tickerItems } from "@/mocks/home";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [hint, setHint] = useState("");

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setHint(query.trim() ? `“${query.trim()}” 为演示检索，实际请从下方分区进入对应图集。` : "请输入人物昵称或事件关键词。");
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="w-full">
      <div className="w-full bg-primary-950 text-background-100">
        <div className="flex items-center gap-4 px-4 py-2 md:px-6">
          <span className="flex shrink-0 items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-accent-400">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-soft-pulse" />
            图文归档
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap text-xs text-background-200">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span key={`${item}-${index}`} className="flex items-center gap-2">
                  <span className="text-accent-500">/</span>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="sticky top-0 z-40 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
        <div className="flex items-center justify-between gap-4 px-4 py-3 md:px-6">
          <h1 className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-image-2-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">黑料照片</span>
              <span className="mt-1 text-[10px] font-medium uppercase tracking-[0.3em] text-foreground-500">
                归档 · 合集 · 原图
              </span>
            </span>
          </h1>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 md:flex">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                type="text"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="搜人物昵称 / 事件关键词"
                className="w-44 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 xl:w-56"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-md bg-secondary-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-secondary-600"
              >
                检索
              </button>
            </form>

            <a
              href="#latest"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              浏览最新收录
            </a>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="展开菜单"
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {hint ? (
          <div className="border-t border-background-200 bg-accent-50 px-4 py-2 text-xs text-accent-900 md:px-6">
            {hint}
          </div>
        ) : null}

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={closeMenu}
                  className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <form onSubmit={handleSearch} className="mt-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                type="text"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="搜人物昵称 / 事件关键词"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
              <button type="submit" className="whitespace-nowrap rounded-md bg-secondary-500 px-3 py-1.5 text-xs font-semibold text-background-50">
                检索
              </button>
            </form>
          </div>
        ) : null}
      </div>
    </header>
  );
}